/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './postgate.defs.js'
export * as $defs from './postgate.defs.js'
